<template>
  <div class="my-2">
    <div v-if="formSubmited">
      <h4>Wave those glowsticks in the air!</h4>
      <p>
        The backstage techs are processing your request. Please check your email
        to continue.
      </p>
    </div>
    <!-- <form @submit.prevent="beforeSubmit" name="org-info" v-if="!formSubmited"> -->
    <form @submit.prevent="recaptcha" name="org-info" v-if="!formSubmited">
      <template v-for="param in Object.keys($route.query)" :key="param">
        <div class="form-group d-none">
          <label :for="param" class="control-label">{{ param }}</label>
          <div>
            <input :value="$route.query[param]" />
            <div class="error-wrapper">
              <p
                v-for="error in formData.orgName.errors"
                v-bind:key="error"
                class="error-message"
              >
                {{ error.message }}
              </p>
            </div>
          </div>
        </div>
      </template>
      <div class="form-group required">
        <p v-if="hasError" class="text-danger">{{ errorMessage }}</p>
        <label for="orgName" class="control-label">Company Name</label>
        <div>
          <input
            type="text"
            maxlength="50"
            name="org-name"
            autocomplete="organization"
            class="form-control"
            data-label="company name"
            @blur="atLeastThreeLetters"
            v-model="formData.orgName.value"
            :class="{ 'is-invalid': formData.orgName.errors.length > 0 }"
            @keyup="removeError('orgName')"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.orgName.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required" id="urlInputGroup">
        <label class="control-label">Choose a URL</label>
        <div class="input-group">
          <input
            type="text"
            maxlength="50"
            name="subdomain"
            id="rlp_subdomain"
            class="form-control subdomain"
            minlength="3"
            placeholder="yourcompany"
            v-model="subDomain"
            :class="{ 'is-invalid': formData.subDomain.errors.length > 0 }"
            @focus="removeError('subDomain', 'domainTaken')"
            @blur="validateOrgUrl"
          />
          <span class="input-group-text right">.rockstarlearning.com</span>
        </div>
        <div
          class="form-text helper-text"
          v-if="
            !isCheckingUrl &&
            !hasUrlBeenChecked &&
            formData.subDomain.errors.length < 1
          "
        >
          This will be your LMS address. Must be at least 3 characters and no
          special characters.
        </div>
        <div class="info-wrapper" v-if="isCheckingUrl">
          <p class="info-message">Checking if URL is available...</p>
          <p
            class="success-message"
            v-if="
              !isCheckingUrl &&
              hasUrlBeenChecked == true &&
              formData.subDomain.errors.length < 1
            "
          >
            URL available
          </p>
        </div>
        <div class="error-wrapper" v-if="formData.subDomain.errors.length > 0">
          <p
            v-for="error in formData.subDomain.errors"
            v-bind:key="error"
            class="error-message"
          >
            {{ error.message }}
          </p>
        </div>
      </div>
      <div class="form-group required mt-1">
        <label class="control-label">Admin First Name</label>
        <div>
          <input
            type="text"
            maxlength="50"
            class="form-control"
            name="admin-first-name"
            autocomplete="given-name"
            v-model="formData.adminFirstName.value"
            :class="{ 'is-invalid': formData.adminFirstName.errors.length > 0 }"
            @focus="removeError('adminFirstName')"
            data-label="first name"
            @blur="atLeastThreeLetters"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.adminFirstName.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">Admin Last Name</label>
        <div>
          <input
            type="text"
            maxlength="50"
            class="form-control"
            name="admin-last-name"
            autocomplete="family-name"
            v-model="formData.adminLastName.value"
            :class="{ 'is-invalid': formData.adminLastName.errors.length > 0 }"
            @focus="removeError('adminLastName')"
            data-label="last name"
            @blur="atLeastThreeLetters"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.adminLastName.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">Admin Email</label>
        <div>
          <input
            type="text"
            maxlength="50"
            class="form-control"
            name="email"
            autocomplete="email"
            v-model="formData.adminEmail.value"
            :class="{ 'is-invalid': formData.adminEmail.errors.length > 0 }"
            @focus="removeError('adminEmail')"
            @blur="isEmailValid"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.adminEmail.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">Mobile Number</label>
        <div>
          <input
            type="tel"
            class="form-control"
            name="phone-number"
            autocomplete="tel"
            v-model="formData.phoneNumber.value"
            :class="{ 'is-invalid': formData.phoneNumber.errors.length > 0 }"
            @keypress="isNumber($event)"
            @focus="removeError('phoneNumber')"
            @blur="isPhoneValid"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.phoneNumber.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">Password</label>
        <div>
          <input
            type="password"
            class="form-control"
            name="password"
            autocomplete="new-password"
            minlength="6"
            required
            v-model="formData.password.value"
            :class="{ 'is-invalid': formData.password.errors.length > 0 }"
            @focus="removeError('password')"
            @blur="countblurs"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.password.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="form-group required">
        <label class="control-label">Re-type password </label>
        <div>
          <input
            type="password"
            class="form-control"
            name="password-compare"
            autocomplete="new-password"
            :class="{
              'is-invalid': formData.confirmPassword.errors.length > 0,
            }"
            v-model="formData.confirmPassword.value"
            @blur="validatePassword"
            @click="removeError('confirmPassword')"
          />
          <div class="error-wrapper">
            <p
              v-for="error in formData.confirmPassword.errors"
              v-bind:key="error"
              class="error-message"
            >
              {{ error.message }}
            </p>
          </div>
        </div>
      </div>
      <div class="policy-holder form-group required">
        <p  :class="{ 'invalid-for-checkbox': formData.acceptTerms.errors.length > 0 }">
        <input
          type="checkbox"
          name="acceptterms"
          required
          v-model="formData.acceptTerms.value"
          :class="{ 'is-invalid': formData.acceptTerms.errors.length > 0 }"
          @click="removeError('acceptTerms')"/>
          
          By checking the box and submitting the information in this form, you agree that use of the free account is subject to the terms and conditions located <a href="https://www.elblearning.com/subscription-and-license-agreement">here</a>. Please print this page as your Ordering Document. As part of your free account, enjoy free access to  Rockstar Learning Platform by ten (10) Authorized Users.
         </p>
         <div class="error-wrapper">
          <p
            v-for="error in formData.acceptTerms.errors"
            v-bind:key="error"
            class="error-message"
          >
            {{error.message}}
          </p>
        </div>
        <p> We use the information you provide us to email you about our products and services. Unsubscribe from these communications at any time by clicking the Unsubscribe link located at the bottom of each email. Learn more in our <a href="https://www.elblearning.com/privacy-policy">Privacy Policy.</a>.*</p>
      </div>
      <div class="btn-container">
        <div
          class="spinner-border action m-auto"
          role="status"
          v-if="isSubmitting"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
        <button
          type="submit"
          class="btn btn-action"
          :disabled="!canSumbit"
          v-else
        >
          {{ $route.name !== "Free" ? "BUY STARTER PLAN" : "GET FREE ACCOUNT" }}
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import * as EmailValidator from "email-validator";
import emailBlockList from "../email-block-list";

export default {
  name: "OrganizationForm",
  data() {
    return {
      isSubmitting: false,
      formData: {
        orgName: { errors: [], value: null },
        subDomain: { errors: [], value: null },
        adminFirstName: { errors: [], value: null },
        adminLastName: { errors: [], value: null },
        adminEmail: { errors: [], value: null },
        phoneNumber: { errors: [], value: null },
        password: { errors: [], value: null },
        confirmPassword: { errors: [], value: null },
        acceptTerms: {errors: [], value: null}
      },
      reCaptchaToken: null,
      hasUrlBeenChecked: false,
      isCheckingUrl: false,
      hasError: false,
      pwblurCount: 0,
      formSubmited: false,
      errorMessage: "",
    };
  },
  computed: {
    subDomain: {
      get: function () {
        return this.formData.subDomain.value;
      },
      set: function (newSubDomain) {
        this.hasUrlBeenChecked = false;
        //Check if this is a valid subdomain name
        this.formData.subDomain.value = newSubDomain;
      },
    },
    canSumbit: {
      get: function () {
        if (!this.hasUrlBeenChecked) {
          return false;
        }
        // Check if any fields are empty
        for (const inputObject in this.formData) {
          if (
            this.formData[inputObject].value == null ||
            this.formData[inputObject].value == undefined ||
            this.formData[inputObject].value == "" ||
            (inputObject === "password" &&
              this.formData[inputObject].value.length < 5) ||
            (inputObject !== "phoneNumber" &&
              inputObject !== "password" &&
              inputObject !== "confirmPassword" &&
              !/(.*[a-zA-Z]){3}/i.test(this.formData[inputObject].value)) ||
            this.formData[inputObject].errors.length > 0
          ) {
            if ( this.formData.acceptTerms.value != true){
              this.validateAcceptTerms()
            }
            return false;
          }
        }
        if (this.formData.password.value !== this.formData.confirmPassword.value) {
          return false;
        }
        if (
          !/^[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]$/.test(
            this.formData.subDomain.value
          )
        ) {
          return false;
        }
        return true;
      },
    },
  },
  created() {
    document.title = `Sign up for the Rockstar Learning Platform - ${this.$route.name}`;
  },
  mounted() {
    window._hsq.push(["setPath", "/rlp-sign-up"]);
    window._hsq.push(["trackPageView"]);
  },
  methods: {
    async recaptcha() {
      if (!this.isSubmitting) {
        this.isSubmitting = true;
        // (optional) Wait until recaptcha has been loaded.
        await this.$recaptchaLoaded();

        const token = await this.$recaptcha("login");
        this.reCaptchaToken = token;
        if (this.canSumbit) {
          this.beforeSubmit();
        }
      }
    },
    kebabToCamel: (str) => str.replace(/([--]\w)/g, (g) => g[1].toUpperCase()),
    atLeastThreeLetters(e) {
      if (!/(.*[a-zA-Z]){3}/i.test(e.target.value)) {
        let data = this.kebabToCamel(e.target.name);
        let label = e.target.getAttribute("data-label");
        let error = [{ message: `Invalid ${label}`, type: "invalid" }];
        this.formData[data].errors = error;
      }
    },
    isPhoneValid() {
      if (
        this.formData.phoneNumber.value !== null &&
        //eslint-disable-next-line
        !/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im.test(
          this.formData.phoneNumber.value
        )
      ) {
        let error = [{ message: "Invalid phone Number", type: "invalid" }];
        this.formData.phoneNumber.errors = error;
      }
    },
    isEmailValid() {
      let domain = this.formData.adminEmail.value.split("@")[1];
      console.log("domain", domain);
      if (emailBlockList.includes(domain)) {
        let errors = [
          {
            type: "invalid",
            message: "Please enter a business email address",
          },
        ];
        this.formData.adminEmail.errors = errors;
        return;
      }
      if (
        this.formData.adminEmail.value !== null &&
        !EmailValidator.validate(this.formData.adminEmail.value)
      ) {
        let errors = [
          {
            type: "invalid",
            message: "Invalid email",
          },
        ];
        this.formData.adminEmail.errors = errors;
      }
    },
    validateOrgUrl() {
      // const apiURl = "https://rockstarlearning.com/api/organization/domaincheck";
      if (
        !/^[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]$/.test(
          this.formData.subDomain.value
        )
      ) {
        let errors = [{ type: "invalid", message: "Invalid subdomain" }];
        this.formData.subDomain.errors = errors;
        return;
      }
      const apiURl = `/api/rlp/organization/domaincheck`;
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          domain: this.formData.subDomain.value,
        }),
      };
      this.isCheckingUrl = true;
      fetch(apiURl, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          if (data.result.isExist == true) {
            this.formData.subDomain.errors.push({
              type: "domainTaken",
              message: "Url is taken, please pick another.",
            });
          }
          // check for error response
          if (!response.ok) {
            return Promise.reject(data.error);
          }
          this.isCheckingUrl = false;
          this.hasUrlBeenChecked = true;
        })
        .catch((error) => {
          // error means org does not exist do nothing
          if (error.code == 50043) {
            console.log("error", error);
          }
          this.isCheckingUrl = false;
          this.formData.subDomain.errors.push({
            type: "rlpDown",
            message: "RLP is down. Please, try again later",
          });
        });
    },
    validateAcceptTerms(){
      let error = [{ message: "You must agree to terms.", type: "empty" }];
      this.formData.acceptTerms.errors = error;
     
    },
    submitOrgForm(data) {
      // POST request using fetch with error handling
      const apiURl = "/api/users";
      const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      };
      fetch(apiURl, requestOptions)
        .then(async (response) => {
          const data = await response.json();
          // check for error response
          if (!response.ok) {
            // get error message from body or default to response status
            // const error = data.error
            return Promise.reject(data.error);
          }
          // Do the next thing

          document.title = `Sign up for the Rockstar Learning Platform - Thank you`;
          window._hsq.push(["setPath", "/rlp-sign-up-submited"]);
          window._hsq.push(["trackPageView"]);
          this.formSubmited = true;
          this.isSubmitting = false;
        })
        .catch((error) => {
          // if error message is stringified json Parse
          if (
            typeof error.message === "string" ||
            error.message instanceof String
          ) {
            let error_message = JSON.parse(
              error.message.substring(error.message.indexOf("{"))
            );
            // if error message is from sendgrid
            if (error_message.validationResults != undefined) {
              this.errorMessage = error_message.validationResults[0].message;
            } else {
              this.errorMessage = error_message.message;
            }
          } else {
            this.errorMessage = error.message.message;
          }
          this.hasError = true;
          console.error("There was an error!", error);
          this.isSubmitting = false;
        });
    },
    beforeSubmit() {
      let inputObject;
      let inErrors = false;
      // Check if any fields are empty
      for (inputObject in this.formData) {
        if (
          this.formData[inputObject].value === null ||
          this.formData[inputObject].value == ""
        ) {
          if (this.formData[inputObject].errors.length > 0) {
            let i;
            for (i = 0; i < this.formData[inputObject].errors.length; i++) {
              if (this.formData[inputObject].errors[i].type === "empty") {
                inErrors = true;
                this.isSubmitting = false;
                break;
              }
            }
          }
          if (!inErrors) {
            this.formData[inputObject].errors.push({
              type: "empty",
              message: "Field cannot be empty.",
            });
          }
        }
      }
      // Check if email is an email address.

      //call api to check if subdomain is taken

      //if form is valid and domain is free send data to table for email.\

      let orgData = {
        user: {
          companyName: this.formData.orgName.value,
          companyUrl: this.formData.subDomain.value,
          firstName: this.formData.adminFirstName.value,
          lastName: this.formData.adminLastName.value,
          phoneNumber: this.formData.phoneNumber.value,
          email: this.formData.adminEmail.value,
          password: this.formData.password.value,
          subscriptionPlan: this.$route.name.toLowerCase(),
          reCaptchaToken: this.reCaptchaToken,
        },
      };

      if (Object.keys(this.$route.query).length > 0) {
        orgData = {
          ...orgData,
          extraData: { ...this.$route.query },
        };
      }
      this.submitOrgForm(orgData);
    },
    //remove the empty error on focus
    removeError(inputObject, type) {
      if (!type) {
        type = "empty";
      }
      this.formData[inputObject].errors = [];
      //TODO: Ask Erin what the lines below should be doing'
      //I WAS removing a single error of a specific type, instead of reseting all errors on input element like it is now. This should be fine, but now type is not needed I would think.
      // this.formData[inputObject].errors = this.formData[
      //   inputObject
      // ].errors.filter(function (obj) {
      //   return obj.type !== type;
      // });
    },
    validatePassword() {
      let inErrors = false;
      if (this.formData.confirmPassword.value != this.formData.password.value) {
        if (this.formData.confirmPassword.errors.length > 0) {
          let i;
          for (i = 0; i < this.formData.confirmPassword.errors.length; i++) {
            if (this.formData.confirmPassword.errors[i].type === "noMatch") {
              inErrors = true;
              break;
            }
          }
        }
        if (!inErrors && this.pwblurCount > 0) {
          this.formData.confirmPassword.errors.push({
            type: "noMatch",
            message: "Passwords must match.",
          });
        }
      } else {
        this.formData.confirmPassword.errors = [];
      }
    },
    isValidPassword() {
      if (this.formData.password.value == undefined || this.formData.password.value == '') {
          return true;
      }
      let password = this.formData.password.value;
      let languageUnicode = [
          '\u4E00-\u9FFF', // Chinese Unified Ideographs
          '\u3400-\u4DBF', // Chinese Unified Ideographs Extension A
          
          '\u314A-\u314E', //Korean
          '\uAC00-\uD7A3', //Korean
          '\uFF01-\uFF03', //Korean
          '\uFF05-\uFF0A', //Korean
          '\uFF0C-\uFF0F', //Korean
          '\uFF1A-\uFF1B', //Korean
          '\uFF1F-\uFF20', //Korean
          '\uFF3B-\uFF3D', //Korean
          '\u1100-\u11FF', //Korean
          '\u3001-\u3003', //Korean
          '\u3008-\u3011', //Korean
          '\u3014-\u3015', //Korean
          '\u2010-\u2011', //Korean
          '\u2014-\u2015', //Korean
          '\u2018-\u2019', //Korean
          '\u201C-\u201D', //Korean
          '\u2020-\u2021', //Korean
          '\u2025-\u2026', //Korean
          '\u2032-\u2033', //Korean
          '\u3141-\u3142', //Korean
          '\u3147-\u3148', //Korean
          '\u314A-\u314E', //Korean

          '\u0E00-\u0E7F', //Thai

          '\u3040-\u309F', //Hiragana

          '\u30A0-\u30FF', //Katakana

          '\u4E00-\u9FFF', //Kanji (Ideographic Characters)
          '\u3400-\u4DBF', //Kanji (Ideographic Characters)
          "\uD840\uDC00-\uD869\uDEDF", //Kanji (Ideographic Characters)

          '\uFF00-\uFFEF', //Halfwidth and Fullwidth Forms

          "\uD83C\uDE00-\uD83C\uDEFF", //Hiragana and Katakana Variants

          'A-Z', //English
          'a-z', //English 
      ];
      let tmpReg = "[" + languageUnicode.join("") + "]+";
      let languageRegex = new RegExp(tmpReg, "u");
      let language = password.match(languageRegex);

      let checkSpaceAtStart = "^[" + languageUnicode.join("") + "0-9!@#\\$%^&*()_+=\\-\\[\\]\\{\\}\\|'“;:\\/?.>,<]" + "[" + languageUnicode.join("") + "0-9!@#\\$%^&*()_+=\\-\\[\\]\\{\\}\\|'“;:\\/?.>,< ]+";
      let checkSpaceAtStartRegex = new RegExp(checkSpaceAtStart, "u");
      let checkAtStartSpace = password.match(checkSpaceAtStartRegex);

      let isEnglishCharRegex = new RegExp("[A-Za-z]", "u");
      let isEnglishChar = password.match(isEnglishCharRegex);

      let uppercaseRegex = new RegExp("[A-Z]", "u");
      let uppercase = password.match(uppercaseRegex);

      let lowercaseRegex = new RegExp("[a-z]", "u");
      let lowercase = password.match(lowercaseRegex);

      let numberRegex = new RegExp("[0-9]", "u");
      let number = password.match(numberRegex);

      let symbols = new RegExp("[!@#\\$%^&*()_+=\\-\\[\\]\\{\\}\\|'“;:\\/?.>,<]", "u");
      let isSymbol = password.match(symbols);

      let passwordLength = password.length;

      if (checkAtStartSpace == null || language == null || passwordLength < 8 || passwordLength > 256 || (isEnglishChar != null && (uppercase == null || lowercase == null || number == null || isSymbol == null))) {
          return false;
      }
      return true;
    },
    countblurs() {
      this.pwblurCount++;
      if (typeof this.formData.confirmPassword.value === "string") {
        this.validatePassword();
      }
      if (!this.isValidPassword()) {
        this.formData.password.errors.push({
          type: "invalid",
          message: "Password must contain 8 or more characters, including lowercase and uppercase, a number and a symbol.",
        });
      }
    },
    isNumber: function (evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      //allows dashes and dots too.
      //Also allowing +
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46 &&
        charCode !== 43 &&
        charCode !== 45
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style scoped>
#urlInputGroup .right {
  border-left: 0;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  display: inline-block;
  padding-left: 0;
  width: 160px;
}
#urlInputGroup input {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  position: relative;
  flex: 1 1 auto;
  width: 1%;
  min-width: 0;
}
.subdomain {
  text-align: right;
}
.invalid-for-checkbox{
  border: 1px solid #dc3545;
  border-radius: 5px;
}
</style>
